// extracted by mini-css-extract-plugin
export default {"row":"Row_row__702mC","index":"Row_index__jfFje","text":"Row_text__p7pcp"};